import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import useScreen from "../../../../providers/screen";
import "./styles/header.css";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    // marginRight: theme.spacing(2),
  },
  title: {
    fontSize: 17,
    display: "none",
    [theme.breakpoints.up("xs")]: {
      display: "block",
    },
  },
}));

const Header = ({ headerTitle, handleBack, onPress, theme }) => {
  let history = useHistory();

  const { screen } = useScreen();

  const classes = useStyles();

  return (
    <>
      <div className={classes.grow}>
        <AppBar
          className={`${screen?.isDesktop && "header-web"}`}
          position="fixed"
        >
          <Toolbar className={`headerContainer ${theme.isDarkTheme && "dark"}`}>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="open drawer"
              onClick={() =>
                onPress
                  ? onPress()
                  : handleBack
                  ? history.push(handleBack)
                  : history.goBack()
              }
            >
              <ArrowForwardIcon />
            </IconButton>
            <Typography className={classes.title} variant="h6" noWrap>
              {headerTitle}
            </Typography>
            <div className={classes.grow} />
          </Toolbar>
        </AppBar>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Header);
